<div class="flex flex-col">
  <div *ngIf="isLoading" class="flex flex-col">
    <header
      class="flex flex-col md:flex-row px-8 py-6 bg-tertiary shadow-md text-white space-y-6 md:space-y-0 md:space-x-6"
    >
      <div class="flex items-center md:w-3/5 space-x-4">
        <div
          class="bg-light/40 animate-pulse rounded-sm w-20 h-20 md:w-24 md:h-24"
        ></div>
        <div class="flex flex-col justify-center space-y-2">
          <div class="h-6 w-32 md:w-40 bg-light/40 animate-pulse rounded"></div>
          <div class="h-4 w-24 md:w-32 bg-light/30 animate-pulse rounded"></div>
          <div class="h-4 w-20 md:w-28 bg-light/30 animate-pulse rounded"></div>
        </div>
      </div>
      <div class="flex justify-around md:w-2/5 text-center w-full">
        <div class="flex flex-col items-center space-y-2">
          <div class="h-8 w-8 bg-light/40 animate-pulse rounded"></div>
          <div class="h-6 w-12 bg-light/40 animate-pulse rounded"></div>
          <div class="h-3 w-16 md:w-20 bg-light/30 animate-pulse rounded"></div>
        </div>
        <div class="flex flex-col items-center space-y-2">
          <div class="h-8 w-8 bg-light/40 animate-pulse rounded"></div>
          <div class="h-6 w-12 bg-light/40 animate-pulse rounded"></div>
          <div class="h-3 w-16 md:w-20 bg-light/30 animate-pulse rounded"></div>
        </div>
        <div class="flex flex-col items-center space-y-2">
          <div class="h-8 w-8 bg-light/40 animate-pulse rounded"></div>
          <div class="h-6 w-12 bg-light/40 animate-pulse rounded"></div>
          <div class="h-3 w-16 md:w-20 bg-light/30 animate-pulse rounded"></div>
        </div>
      </div>
    </header>
    <nav class="flex flex-wrap bg-tertiary px-8 py-3 space-x-4 md:space-x-6">
      <div class="h-6 w-20 md:w-24 bg-light/40 animate-pulse rounded"></div>
      <div class="h-6 w-28 md:w-32 bg-light/40 animate-pulse rounded"></div>
      <div class="h-6 w-24 md:w-28 bg-light/40 animate-pulse rounded"></div>
      <div class="h-6 w-24 md:w-28 bg-light/40 animate-pulse rounded"></div>
    </nav>
    <main class="bg-light px-6 md:px-14 py-10 md:py-20 min-h-[70vh]">
      <section class="bg-white rounded-md w-full p-6">
        <div class="space-y-4">
          <div
            class="h-6 w-2/3 md:w-1/3 bg-light/40 animate-pulse rounded"
          ></div>
          <div
            class="h-4 w-3/4 md:w-2/3 bg-light/30 animate-pulse rounded"
          ></div>
          <div
            class="h-4 w-2/3 md:w-1/2 bg-light/30 animate-pulse rounded"
          ></div>
          <div
            class="h-4 w-4/5 md:w-3/4 bg-light/30 animate-pulse rounded"
          ></div>
        </div>
      </section>
    </main>
  </div>
  <header
    *ngIf="!isLoading"
    class="flex flex-col md:flex-row px-8 py-6 bg-tertiary shadow-md text-white space-y-6 md:space-y-0 md:space-x-6"
  >
    <div class="flex items-center md:w-3/5 space-x-4">
      <div
        class="bg-white/20 relative rounded-sm w-20 h-20 md:w-24 md:h-24 flex items-center justify-center text-white text-2xl font-bold"
      >
        <img
          [src]="companyImage"
          alt="imagen"
          class="w-full h-full object-cover rounded-sm"
        />
        <button
          (click)="openModalUploadImage()"
          class="absolute -bottom-2 -right-2 bg-white text-primary rounded-full h-8 w-8 shadow-md hover:scale-105 transition-transform"
        >
          <ng-icon name="heroPencil" size="20"></ng-icon>
        </button>
      </div>
      <div class="flex flex-col justify-center">
        <h1 class="text-lg md:text-xl font-semibold text-white">
          {{ company?.commercialName }}
        </h1>
        <p class="text-sm text-white/70">Administración de la compañía</p>
        @if(!isVerified()){
        <div class="flex items-center mt-2 text-yellow-200 font-medium">
          <ng-icon name="heroInformationCircle" size="20"></ng-icon>
          <p
            (click)="openModal()"
            class="text-sm hover:underline ml-2 cursor-pointer"
          >
            No verificado
          </p>
        </div>
        } @else{
        <div class="flex items-center mt-2 text-green-200 font-medium">
          <ng-icon name="heroCheckBadge" size="20"></ng-icon>
          <p class="text-sm ml-2">Verificado</p>
        </div>
        }
      </div>
    </div>
    <div class="flex justify-around md:w-2/5 text-center w-full">
      <div class="flex flex-col items-center">
        <ng-icon name="featherClipboard" size="28" class="mb-2"></ng-icon>
        <p class="text-2xl md:text-3xl font-bold">{{ stasts.numJobOffers }}</p>
        <p class="text-xs md:text-sm text-white/70">Total de ofertas</p>
      </div>
      <div class="flex flex-col items-center">
        <ng-icon name="featherUser" size="28" class="mb-2"></ng-icon>
        <p class="text-2xl md:text-3xl font-bold">
          {{ stasts.numJobOffersPublished }}
        </p>
        <p class="text-xs md:text-sm text-white/70">Ofertas activas</p>
      </div>
      <div class="flex flex-col items-center">
        <ng-icon name="featherCalendar" size="28" class="mb-2"></ng-icon>
        <p class="text-2xl md:text-3xl font-bold">
          {{ stasts.numJobOffersFinalized }}
        </p>
        <p class="text-xs md:text-sm text-white/70">Ofertas finalizadas</p>
      </div>
    </div>
  </header>
  <nav
    *ngIf="!isLoading"
    class="flex overflow-x-auto pr-10 flex-nowrap bg-tertiary px-6 md:px-8 py-3 text-white scrolling-touch"
  >
    <div class="flex flex-nowrap">
      <a
        routerLink="./"
        routerLinkActive="border-b-2 border-white font-medium text-white"
        [routerLinkActiveOptions]="{ exact: true }"
        class="mr-4 md:mr-6 pb-2 flex items-center space-x-2 text-gray-400 hover:text-white transition-colors shrink-0"
      >
        <ng-icon name="featherInfo" size="20"></ng-icon>
        <span>Información</span>
      </a>
      <a
        [class.pointer-events-none]="!isVerified()"
        [class.text-white]="!isVerified()"
        [class.cursor-not-allowed]="!isVerified()"
        [routerLink]="isVerified() ? 'job-offers' : null"
        routerLinkActive="border-b-2 border-white font-medium text-white"
        class="mr-4 md:mr-6 pb-2 text-gray-400 flex items-center space-x-2 transition-colors hover:text-white shrink-0"
      >
        <ng-icon name="featherBriefcase" size="20"></ng-icon>
        <span>Ofertas de trabajo</span>
      </a>
      <a
        routerLink="my-package"
        routerLinkActive="border-b-2 border-white font-medium text-white"
        class="mr-4 md:mr-6 pb-2 text-gray-400 flex items-center space-x-2 transition-colors hover:text-white shrink-0"
      >
        <ng-icon name="featherBox" size="20"></ng-icon>
        <span>Paquetes</span>
      </a>
      <a
        routerLink="members"
        routerLinkActive="border-b-2 border-white font-medium text-white"
        class="mr-4 md:mr-6 pb-2 text-gray-400 flex items-center space-x-2 transition-colors hover:text-white shrink-0"
      >
        <ng-icon name="heroUsers" size="20"></ng-icon>
        <span>Colaboradores</span>
      </a>
    </div>
  </nav>
  <main *ngIf="!isLoading" class="bg-light px-2 sm:px-6 md:px-14 py-2 sm:py-6">
    <section class="bg-white rounded-md w-full p-3 sm:p-6">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
<app-image-upload-modal
  *ngIf="showModalUpdate"
  [loading]="modalLoading"
  (close)="showModalUpdate = false"
  (imageSelected)="uploadLogo($event)"
></app-image-upload-modal>
<app-verification-modal
  *ngIf="showVerificationModal"
  #verificationModal
  (resend)="handleResend()"
  (completed)="handleCompleted($event)"
  (close)="closeVerificationModal()"
>
</app-verification-modal>
